module.exports = __webpack_public_path__ + "img/Service2.79735d2c.png";